import React, { Fragment, useState, useCallback } from "react";
import moment from "moment";
import * as GoogleAnalytics from "../../lib/google-analytics";
import MobilekeyMenual from "./MobilekeyMenual";
import CheckOut from "./CheckOut";

const BookingList = ({ bookingItem, checkOut, history }) => {
  const [isOpenModalMobilekeyMenual, setIsOpenModalMobilekeyMenual] = useState(false);
  const [isOpenModalCheckOut, setIsOpenModalCheckOut] = useState(false);

  const openModalMobilekeyMenual = useCallback(() => {
    GoogleAnalytics.customEvent({
      category: "button_click",
      action: "button_click_mobilekey_menual",
    });
    setIsOpenModalMobilekeyMenual(true);
  }, []);

  const closeModalMobilekeyMenual = useCallback(() => {
    setIsOpenModalMobilekeyMenual(false);
  }, []);

  const openModalCheckout = useCallback(() => {
    GoogleAnalytics.customEvent({
      category: "button_click",
      action: "button_click_checkout_request",
    });
    setIsOpenModalCheckOut(true);
  }, []);

  const closeModalCheckOut = useCallback(() => {
    setIsOpenModalCheckOut(false);
  }, []);

  const roomNoFormatter = (roomNo) => {
    return roomNo ? parseInt(roomNo.slice(roomNo.length - 4)) : roomNo;
  };

  const dayFormatter = (day) => {
    return (
      {
        Sun: "일",
        Mon: "월",
        Tue: "화",
        Wed: "수",
        Thu: "목",
        Fri: "금",
        Sat: "토",
      }[day] || day
    );
  };

  const setBookingDate = (date) => {
    return `${moment(date).format("YYYY.MM.DD")} (${dayFormatter(moment(date).format("ddd"))})`;
  };

  const setBookingTime = (time) => {
    return `${time.slice(0, 2)}:${time.slice(2, 4)}`;
  };

  return (
    <Fragment>
      <div className="checked-in-background-container">
        <div className="opacity-background">
          <span className="welcome-message">
            {bookingItem.inhsGestName} 고객님,
            <br />
            환영합니다.
          </span>
          <div className="booking-id-container">
            <span className="booking-id-label">예약번호</span>
            <span className="booking-id-value">{bookingItem.reservationNo}</span>
          </div>
        </div>
      </div>
      <div className="checked-in-booking-card-container">
        <span className="hotel-name">{bookingItem.propertyName}</span>
        <span className="room-name">{roomNoFormatter(bookingItem.roomNo)}</span>
        <div className="horizontal-line mt-15 mb-20"></div>
        <div className="userkey-container">
          <div className="userkey-item">
            <span className="userkey-item-label">객실 비밀번호</span>
            <span className="userkey-item-value">{bookingItem.entranceNo || "-"}</span>
          </div>
          <div className="userkey-item">
            <span className="userkey-item-label">
              모바일키
              <img className="tip-icon ml-2 mb-4" src="../../assets/images/question-mark.png" alt="" onClick={openModalMobilekeyMenual} />
            </span>
            <span className="userkey-item-value">{bookingItem.mobileRoomKey || "-"}</span>
          </div>
        </div>
        <div className="checked-in-booking-period-container">
          <img className="period-icon mt-2" src="../../assets/images/period.png" alt="" />
          <div className="period-item-container">
            <div className="period-item mb-8">
              <span className="period-item-label">체크인</span>
              <span className="period-item-value">
                {bookingItem.arrvDate
                  ? `${setBookingDate(bookingItem.arrvDate)} ${
                      bookingItem.arrvPlanTime && bookingItem.arrvPlanTime.length === 4 ? setBookingTime(bookingItem.arrvPlanTime) : "15:00"
                    }`
                  : "-"}
              </span>
            </div>
            <div className="period-item">
              <span className="period-item-label">체크아웃</span>
              <span className="period-item-value">
                {bookingItem.deptDate
                  ? `${setBookingDate(bookingItem.deptDate)} ${
                      bookingItem.deptPlanTime && bookingItem.deptPlanTime.length === 4 ? setBookingTime(bookingItem.deptPlanTime) : "11:00"
                    }`
                  : "-"}
              </span>
            </div>
          </div>
        </div>
        <div className="check-out-button-container">
          <span className="check-out-button" onClick={openModalCheckout}>
            비대면 체크아웃 하기
          </span>
        </div>
        <div className="horizontal-line mt-15 mb-30"></div>
        <div className="checked-in-booking-room-notice">
          <pre className="fw-default ws-pl fw-300">
            <span className="fw-500">{`<셀프 체크인 안내 사항>`}</span>
            <br />
            <br />
            {`1. 셀프 체크인으로 발행된 비밀번호는 체크인 15:00, 체크아웃 11:00 기준으로 사용 가능하며, 시간이 초과될 경우 도어록 사용이 어렵습니다.
(패키지, 특가 이용시 체크인,아웃 시간이 변동 될 수 있습니다.)

2. 셀프 체크인은 체크인 시간 이후, 호텔 반경 3km 이내에서만 체크인이 가능합니다.

3. 셀프 체크인을 한 경우 잔여 결제금이 없는 때에만 셀프 체크아웃 가능합니다.

4. 패키지 이용 시 제공 품목을 모르시는 경우 프런트로 문의 부탁드립니다.
관광지 쿠폰 및 제공 상품은 프런트에서 수령 가능합니다.

5. 연박, 레이트 체크아웃을 요청하는 경우 프런트로 문의 부탁드립니다.

6. 피트니스 센터를 이용하고자 하는 고객께서는 프런트로 방문하여 객실키를 발급받아 주시기 바랍니다.

셀프 체크인은 객실 요금이 지불된 예약 건만 가능하며, 예약 정보에 따라 셀프 체크인이 어려울 수 있습니다.`}
            <br />
            <br />
            <span className="fw-500">{"[호텔 이용 안내 및 문의]"}</span>
            <br />
            <a href="https://litt.ly/utopmarina">링크</a> 클릭하셔서 카카오톡으로 문의주시면 보다 빠른 응대가 가능합니다.
            <br />
            <br />
            <span className="fw-500">문의 061-690-8000</span>
            <br />
            <br />
            <span className="fw-500">내선 - 프런트 0번</span>
          </pre>
        </div>
      </div>
      <MobilekeyMenual isOpen={isOpenModalMobilekeyMenual} onClose={closeModalMobilekeyMenual} />
      <CheckOut isOpen={isOpenModalCheckOut} onClose={closeModalCheckOut} checkOut={checkOut} />
    </Fragment>
  );
};

export default BookingList;
